import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function CTABanner() {
  return <section className="bg-gold relative overflow-hidden" data-id="element-34">
      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#1A3621 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-35"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10" data-id="element-36">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left lg:max-w-2xl" data-id="element-38">
            <h2 className="text-4xl md:text-5xl font-bold text-forest-dark mb-4 font-serif" data-id="element-39">
              Ready to Transform Your Outdoor Space?
            </h2>
            <p className="text-xl text-forest-dark/80 font-medium" data-id="element-40">
              Contact us today for a free, no-obligation estimate on your next
              project.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-41">
            <a href="tel:360-623-4531" className="flex items-center justify-center gap-3 bg-forest-dark hover:bg-forest text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-xl hover:shadow-2xl" data-id="element-42">
              <PhoneIcon className="w-6 h-6 text-gold" data-id="element-43" />
              Call 360-623-4531
            </a>
            <a href="#contact" className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-forest-dark px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-xl hover:shadow-2xl group" data-id="element-44">
              Get Free Estimate
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-45" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}